import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import classnames from 'classnames'
import IconImg from '../../assets/img/integral-icon-0.png'
import CardDec from '../../assets/img/integral-card-dec.png'
import { withTranslation } from 'react-i18next'

let classWrapper = 'integral-card__wrapper'
let classBody = 'integral-card__body'
switch (process.env['REACT_APP_CHANNEL']) {
  case 'haiou':
    classWrapper += ' integral-card__wrapper--haiou'
    classBody += ' integral-card__body--haiou'
    break
  // case 'xibei':
  // case 'xiniu':
  // case 'tradeasy':
  //   break
  default:
    classWrapper += ' integral-card__wrapper--xiniu'
    classBody += ' integral-card__body--xiniu'
}

@withTranslation()
@connect(state => {
  return {
    store: state.integralList.userData
  }
})
@withRouter
class IntegralCard extends React.PureComponent {
  static propTypes = {
    isDetails: PropTypes.bool
  }

  render () {
    const { t, isDetails } = this.props
    const { integral } = this.props.store
    let classes = classnames(classWrapper, { 'integral-details__card': isDetails })
    return <div className={classes}>
      <div className={classBody}>
        <img className="integral-card__dec" src={CardDec} alt=""/>
        <div className="integral-card__title"><img src={IconImg} alt=""/>&nbsp;{t('integral.card_title')}</div>
        <div className="integral-card__value">{Number(integral) >= 0 ? integral : '-'}</div>
        <div className="integral-card__extend" onClick={this.goToDetails}>{t('integral.card_sub')} <i
          className={'icon-font icon-arrow-right-bold'}/></div>
      </div>
    </div>
  }

  goToDetails = () => {
    this.props.history.push(window.PATH.INTEGRAL_DETAILS)
  }
}

export default IntegralCard
